export default class Filter {
  static init() {
    return new Filter();
  }

  constructor() {
    document.querySelectorAll('.link-advanced-search').forEach(($el) => {
      $el.dataset.hiddenText = '<i class="fas fa-caret-down font-high-green"></i> Busca avançada';
      $el.dataset.shownText = '<i class="fas fa-caret-up font-high-green"></i> Busca avançada';
    });
  }
};